export const FAVORITES_CHAT_TITLE = 'Избранное';

export function normalizeChatType(chat) {
  const t = chat?.type ?? chat?.chat_type;
  if (typeof t === 'string') return t.toLowerCase();
  if (t && typeof t === 'object') return String(t.value || t.name || 'group').toLowerCase();
  return 'group';
}

export function isFavoritesChat(chat) {
  if (!chat || chat.__virtual) return false;
  if (chat.is_favorites === true || chat.isFavorites === true) return true;
  return normalizeChatType(chat) === 'favorites';
}

export function getChatDisplayTitle(chat) {
  if (isFavoritesChat(chat)) return FAVORITES_CHAT_TITLE;
  return chat?.title || chat?.name || '';
}
